import React from 'react';
export function TickCircleFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.015 2H12a10 10 0 00-.016 20H12a10 10 0 10.014-20zm3.874 8.586l-4.243 4.242a1 1 0 01-1.414 0L8.11 12.707a1 1 0 011.414-1.414l1.414 1.414 3.536-3.535a1 1 0 011.414 1.414z"
  }));
}